import template from './ko-render-field.html';

/**
 * Render fields knockout component class
 * @kind component
 * @class SampleComponent
 * @description Sample Component that shows the name value
 */
class ComponentViewModel
{
	constructor(params)
	{
		this.field = ko_helper.safe_observable(params);
		this.required = ko_helper.safe_observable(params.required, false);
		this.hide_labels = ko_helper.safe_observable(params.hide_labels, false);
		this.field_error = ko.observable(false);

		this.component_name = null;
		this.params = {};

		this.renderField();
		this.setupValidation();
	}

	setupValidation()
	{
		if (this.required())
		{
			if (this.params && this.params.$input)
			{
				this.params.$input.subscribe((new_value) => {
					// Clear error when user starts typing valid content
					if (this.field_error() && new_value && new_value.toString().trim() !== '') {
						this.field_error(false);
					}
					// Show error when field becomes empty and is required
					else if (this.required() && (!new_value || new_value.toString().trim() === '')) {
						this.field_error(true);
					}
				});
			}
		}
	}

	// Method to validate on blur (when user leaves the field)
	validateOnBlur()
	{
		if (this.required())
		{
			this.validate();
		}
	}
	
	validate()
	{
		if (!this.required())
			return true;
			
		let isValid = true;
		
		if (this.params && this.params.$input)
		{
			// Check single field value
			let value = this.params.$input();
			isValid = value && value.toString().trim() !== '';
		}
		
		this.field_error(!isValid);
		return isValid;
	}

	renderField()
	{
		const field = this.field();

		this.component_name = this.getComponentForFieldType(field.type);

		if (!this.component_name)
		{
			console.warn(new Error(`No component for field ${field.name} with type=${field.type}`));
			this.component_name = this.getComponentForFieldType('text');
		}

		let params = Object.assign({ $input: null, label: null },
			field,
			field.options
		);

		params -"$raw";

		if (!field.label && field.name)
		{
			params.label = field.name;
			params.label = params.label.replace(/_/g, ' ');
			params.label = params.label.replace(/\b\w/g, char => char.toUpperCase());
		}

		if (!params.$input || !ko.isObservable(params.$input))
			params.$input = ko.observable();

		if (field.default_value)
			params.$input(field.default_value);

		params.hide_labels = this.hide_labels();

		this.params = params;
	}

	getComponentForFieldType(name)
	{
		let FieldType = Grape.registry.getItem('RenderFieldsFieldTypes', name);

		if (!FieldType)
		{
			console.error(new Error(`Unknown render field type "${name}". Falling back to "text"`));
			FieldType = Grape.registry.getItem('RenderFieldsFieldTypes', 'text');
		}

		return FieldType?.component;
	}
}

export default {
	name: 'ko-render-field',
	viewModel: ComponentViewModel,
	module_type: 'ko',
	template: template
};
